import { Component, OnInit, TemplateRef } from "@angular/core";
import { BsModalRef } from "ngx-bootstrap/modal/bs-modal-ref.service";
import { IOption } from "ng-select";
import { FormBuilder, FormGroup } from "@angular/forms";
import { EvsStampService } from "../../../../common/services/EvsStamp.service";
import { EvsAddressService } from "../../../../common/services/EvsAddress.service";
import { BatchService } from "../batchstamp/batch.service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs/Subscription";
import { BsModalService } from "ngx-bootstrap";
import { ConfirmBatchStampService } from "./confirm-batch-stamp.service";
declare var $: any;

@Component({
  selector: "distribution-modal-content",
  templateUrl: "./modalDistribution.template.html",
  styleUrls: ["./modalDistribution.css"],
  providers: [ConfirmBatchStampService],
})
export class ModalDistributionComponent implements OnInit {
  batch_detail: any;
  closeBtnName: string;
  confirm: boolean = false;
  data;

  public message: any = { type: "", content: "" };
  public FormDistribution: FormGroup;
  store: any = {};
  storeFocus: boolean = false;
  list_store: Array<IOption> = [];
  list_cities: Array<IOption> = [];
  cities: Array<IOption> = [];
  list_districts: Array<IOption> = [];
  selected_city: boolean = false;
  store_id: number = 0;
  city_from_store: any = null;
  district_from_store: any = null;
  address_from_store: any = null;
  store_selected: any = {};
  toCity: any = [];
  list_success: Array<any> = [];
  list_fail: Array<any> = [];

  id_start: any = null;
  id_end: any = null;
  prefix: any = "";
  serial: any = null;

  has_list_batch: boolean = false;
  list_batches: Array<IOption> = [];
  public selected_batch: any = "";
  distribution_fom_batch: any = true;

  loading: boolean = false;

  modalRef: BsModalRef;

  constructor(
    private fb: FormBuilder,
    public bsModalRef: BsModalRef,
    private stampService: EvsStampService,
    private addressService: EvsAddressService,
    private batchService: BatchService,
    private toastr: ToastrService,
    private modalService: BsModalService,
    private confirmBatchStampService: ConfirmBatchStampService
  ) {}

  ngOnInit() {
    if (this.batch_detail) {
      this.id_start = this.formatSerialMinSixCharacter(
        this.batch_detail.id_start
      );
      this.batch_detail.id_start_f = this.formatSerialMinSixCharacter(
        this.batch_detail.id_start
      );
      this.id_end = this.formatSerialMinSixCharacter(this.batch_detail.id_end);
      this.batch_detail.id_end_f = this.formatSerialMinSixCharacter(
        this.batch_detail.id_end
      );
      this.prefix = this.batch_detail.prefix;
      this.selected_batch = true;
    }
    this.createForm();
    this.getListStore();
    this.getListCities();
    this.getListCitiesDistribution();
    this.listBatches(true);
  }

  createForm() {
    this.FormDistribution = this.fb.group({
      id_start: [this.id_start],
      id_end: [this.id_end],
      serial: [this.serial],
      batch_id: [null],
      store_id: [null],
      to_city: [null],
      // cityFromStore: [this.city_from_store],
      to_district: [null],
      // districtFromStore: [this.district_from_store],
      to_address: [null],
      note: [null],
    });
  }

  listBatches(get = false) {
    if (get && !this.has_list_batch) {
      this.batchService
        .getBatchesList({ service: 3, status: 2, show_child: 1, limit: 500 })
        .toPromise()
        .then((res: any) => {
          if (res.error == false) {
            this.has_list_batch = true;
            let batches = [];
            for (let batch of res.data.batches) {
              batches.push({
                value: batch.id,
                label: "#" + batch.id + ":" + batch.name,
              });
            }
            this.list_batches = batches;
          } else {
            console.log("getBatchesList:error", res);
          }
        })
        .catch((err: any) => {
          console.log("getBatchesList:catch", err);
        });
    }
  }

  parse_int(s) {
    return parseInt(s);
  }

  formatSerialMinSixCharacter(serial) {
    let serial6char: string = "";
    serial = serial.toString();
    if (serial) {
      let pad = "000000";
      serial6char = pad.substring(0, 6 - serial.length) + serial;
    }
    return serial6char;
  }

  submitDistribution(data) {
    this.data = data;
    this.loading = true;
    let request: any = {};
    if (this.batch_detail && this.batch_detail.id) {
      request.batch_id = this.batch_detail.id;
    } else if (data.batch_id) {
      request.batch_id = data.batch_id;
    }

    if (data.serial && !request.batch_id) {
      request.serial = data.serial;
    }

    if (data.id_start && data.id_end && request.batch_id) {
      request.id_start = parseInt(data.id_start);
      request.id_end = parseInt(data.id_end);
    }
    if (this.store.id) {
      request.store_id = this.store.id;
      request.city = [this.store_selected.province];
      if (this.store_selected.district) {
        request.district = [this.store_selected.district];
      }
      if (data.to_address) {
        request.address = data.to_address;
      }
    } else {
      if (data.to_city) {
        request.city = data.to_city;
      }
      if (data.to_district && data.to_city && data.to_city.length == 1) {
        request.district = data.to_district;
      }
      if (data.to_address) {
        request.address = data.to_address;
      }
    }

    if (data.note) {
      request.note = data.note;
    }
    request.confirm = this.confirm;

    console.log("confirm", request.confirm);
    this.bacthStamp(request);
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: "modal-sm" });
  }

  getListStore() {
    if (this.store.name) {
      this.stampService
        .getAllStore({
          desc: "id",
          status: 1,
          limit: 500,
          deleted: 0,
          name: this.store.name,
        })
        .toPromise()
        .then((res: any) => {
          if (res.error == false) {
            let all_store = [];
            if (res.data.store.length > 0) {
              for (let p of res.data.store) {
                all_store.push({ value: p.id, label: p.name });
              }
              this.list_store = all_store;
            } else {
              delete this.store.id;
              this.list_store = [];
            }
            this.selected_store();
            this.deselected_store();
          } else {
            console.log("error:true", res.message);
          }
        })
        .catch((err: any) => {
          console.log("catch:", err);
        });
    } else {
      delete this.store.id;
      this.list_store = [];

      this.deselected_store();
    }
  }

  getListCities() {
    this.addressService
      .getCities()
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let cities = [];

          for (let p of res.data.cities) {
            cities.push({ value: p.id, label: p.name });
          }
          this.cities = cities;
        } else {
          console.log("error:true", res.message);
        }
      })
      .catch((err: any) => {
        console.log("catch:", err);
      });
  }
  getListCitiesDistribution() {
    this.addressService
      .getCitiesDistribution()
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let cities = [];

          for (let p of res.data.cities) {
            cities.push({ value: p.id, label: p.name });
          }
          this.list_cities = cities;
          // console.log(this.list_cities);
        } else {
          console.log("error:true", res.message);
        }
      })
      .catch((err: any) => {
        console.log("catch:", err);
      });
  }

  selected_store() {
    if (this.store.id) {
      this.store_id = this.store.id;

      this.stampService
        .getStore(this.store.id)
        .toPromise()
        .then((res: any) => {
          if (res.error == false) {
            this.store_selected = res.data;
            this.city_from_store = res.data.province_name;
            this.district_from_store = res.data.district_name;
            this.address_from_store = res.data.address;
          } else {
            this.store_selected = {};
            this.message.class = "warning";
            this.message.content = res.message;
            console.log("error:true", res.message);
          }
        })
        .catch((err: any) => {
          this.store_selected = {};
          console.log("catch", err);
        });
    }
  }

  deselected_store() {
    if (!this.store.id) {
      this.store_selected = {};
      this.store_id = 0;
      this.city_from_store = null;
      this.district_from_store = null;
      this.address_from_store = null;
    }
  }

  selectedCity(event) {
    let city_id = event.value;
    this.selected_city = true;
    this.getDistrictByCity(city_id);
  }

  deselectedCity() {
    if (this.toCity && this.toCity.length == 1) {
      this.getDistrictByCity(this.toCity[0]);
    } else if (!this.toCity || this.toCity.length == 0) {
      this.list_districts = null;
      this.selected_city = false;
    }
  }

  selectedBatch(event) {
    let batch_id = event.value;
    this.batchService
      .getBatchDetail(batch_id)
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          this.selected_batch = true;
          this.id_start = this.formatSerialMinSixCharacter(res.data.id_start);
          this.id_end = this.formatSerialMinSixCharacter(res.data.id_end);
          this.prefix = res.data.prefix;
          this.batch_detail = {
            id_start: res.data.id_start,
            id_start_f: this.formatSerialMinSixCharacter(res.data.id_start),
            id_end: res.data.id_end,
            id_end_f: this.formatSerialMinSixCharacter(res.data.id_end),
            prefix_id: res.data.prefix_id,
            prefix: res.data.prefix,
          };
        } else {
          this.selected_batch = false;
          this.id_start = null;
          this.id_end = null;
          this.prefix = null;
          this.batch_detail = null;
          console.log("getBatchDetail:error", res);
        }
      })
      .catch((err: any) => {
        this.selected_batch = false;
        this.id_start = null;
        this.id_end = null;
        this.prefix = null;
        this.batch_detail = null;
        console.log("getBatchDetail:catch", err);
      });
  }
  deselectedBatch() {
    this.selected_batch = false;
    this.id_start = null;
    this.id_end = null;
    this.prefix = null;
    this.batch_detail = null;
  }

  getDistrictByCity(city_id) {
    this.addressService
      .getDistrict({ city_id: city_id })
      .toPromise()
      .then((res: any) => {
        if (res.error == false) {
          let districts = [];
          for (let p of res.data.districts) {
            districts.push({ value: p.id, label: p.name });
          }
          this.list_districts = districts;
        } else {
          console.log("error:true", res.message);
        }
      })
      .catch((err: any) => {
        console.log("catch:", err);
      });
  }

  /*function phan phoi lo tem cho khach hang*/
  bacthStamp(request) {
    this.batchService
      .createDistribution(request)
      .toPromise()
      .then((res: any) => {
        this.loading = false;
        console.log(res);
        /*kiem tra xem lo tem da duoc phan phoi chua*/
        if (res.data && res.data.showPopup) {
          //show popup
          console.log(res.data.message);
          let title = "Cảnh báo trùng serials!";
          let message = res.data.message;
          let options = ["Yes", "No"];
          this.confirmBatchStampService
            .confirm(title, message, options)
            .subscribe((answer) => {
              console.log("anser", answer);
              if (answer === "Yes") {
                this.confirm = true;
                this.submitDistribution(this.data);
              } else {
                this.confirm = false;
              }
            });
        } else {
          if (res.error == false) {
            this.list_success.push(res.data);

            if (this.batch_detail && this.batch_detail.id) {
              // phan phoi tu trang lo tem thì moi tat popup
              this.bsModalRef.hide();
            }
            this.toastr.success("Phân phối tem thành công!", "Thông báo:", {
              timeOut: 4000,
              positionClass: "toast-top-right",
            });
          } else {
            let mess = res.message
              ? res.message
              : "Thao tác phân phối tem không thành công. Vui lòng thử lại sau";
            this.toastr.warning(mess, "Thông báo:", {
              timeOut: 4000,
              positionClass: "toast-top-right",
            });
            console.log("createDistribution:error", res);
          }
        }
      })
      .catch((err: any) => {
        this.loading = false;
        let mess = err.message
          ? err.message
          : "Thao tác phân phối tem không thành công. Vui lòng thử lại sau";
        this.toastr.warning(mess, "Thông báo:", {
          timeOut: 4000,
          positionClass: "toast-top-right",
        });
        console.log("createDistribution:catch", err);
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/popup/modalDistribution.component.ts